export interface IPricesHubDataSource {
    source: string;
    shows: string;
    scope: string;
    updateFrequency: string;
}

export const PRICES_HUB_DATA_SOURCE_COLUMNS = {
    source: "Źródło",
    shows: "Co pokazuje",
    scope: "Zakres danych",
    updateFrequency: "Częstotliwość aktualizacji"
} as const;

export const PRICES_HUB_DATA_SOURCES: IPricesHubDataSource[] = [
    {
        source: "Ceny ofertowe – RynekPierwotny.pl",
        shows: "Aktualne ceny mieszkań oferowanych przez deweloperów",
        scope: "Dane dla miast i dzielnic w całej Polsce",
        updateFrequency: "Co miesiąc"
    },
    {
        source: "Ceny transakcyjne – Rejestr Cen Nieruchomości",
        shows: "Ceny zapisane w aktach notarialnych po sprzedaży mieszkania",
        scope: "Dane lokalne o pojedynczych transakcjach",
        updateFrequency: "Na bieżąco, po publikacji danych"
    }
];
export interface IPricesHubDataSource {
    source: string;
    shows: string;
    scope: string;
    updateFrequency: string;
}

export const PRICES_HUB_DATA_SOURCE_COLUMNS = {
    source: "Źródło",
    shows: "Co pokazuje",
    scope: "Zakres danych",
    updateFrequency: "Częstotliwość aktualizacji"
} as const;

export const PRICES_HUB_DATA_SOURCES: IPricesHubDataSource[] = [
    {
        source: "Ceny ofertowe – RynekPierwotny.pl",
        shows: "Aktualne ceny mieszkań oferowanych przez deweloperów",
        scope: "Dane dla miast i dzielnic w całej Polsce",
        updateFrequency: "Co miesiąc"
    },
    {
        source: "Ceny transakcyjne – Rejestr Cen Nieruchomości",
        shows: "Ceny zapisane w aktach notarialnych po sprzedaży mieszkania",
        scope: "Dane lokalne o pojedynczych transakcjach",
        updateFrequency: "Na bieżąco, po publikacji danych"
    }
];
